<template>
  <div id="team-list">

    <div class="items-grid-view vx-row match-height" v-if="teamList.length" appear>
        <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full" v-for="item in teamList" :key="item.objectID" :title="item.title">
            <item-grid-view :item="item">
                <!-- SLOT: ACTION BUTTONS -->
                <template slot="action-buttons">
                    <div class="flex flex-wrap">

                        <div
                            class="item-view-secondary-action-btn bg-primary p-3 flex flex-grow items-center justify-center text-white cursor-pointer"
                            @click="goToTeamDetail(item)">
                            <feather-icon icon="UsersIcon" svgClasses="h-4 w-4" />

                            <span class="ml-2">查看团队信息</span>
                        </div>
                        <div
                            class="item-view-primary-action-btn p-3 flex flex-grow items-center justify-center cursor-pointer"
                            @click="openConfirm(item)">
                            <feather-icon icon="XIcon" svgClasses="h-4 w-4" />

                            <span class="ml-2">退出团队</span>
                        </div>
                        
                    </div>
                </template>
            </item-grid-view>
        </div>
    </div>
    <div v-else>
      <div class="flex mb-4">
        <span class="text-2xl font-medium mr-4 py-2">我的账号: {{ username }}</span>
        <vs-button 
          size="small" 
          type="flat" 
          icon-pack="feather" 
          icon="icon-copy"
          v-clipboard:copy="username"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
        >复制</vs-button>
      </div>
      <vs-alert>你还没有加入任何团队喔。复制我的账号给已经创建团队的队长，把你邀请进入团队吧！</vs-alert>
    </div>
  </div>
</template>

<script>
import { list, exitTeam } from "@/api/team";
import { getToken } from "@/utils/tools";

const ItemGridView = () => import("./components/ItemGridView.vue");

export default {
  data() {
    return {
      teamList: [],
      addNewDataSidebar: false,
      addModel: true,
      currentTeam: null,
      username: '',
    };
  },
  components: {
    ItemGridView,
  },
  computed: {
    listitems() {
      return this.teamList;
    },
  },
  methods: {
    getList() {
      let that = this;
      list({
        access_token: getToken(),
        type: 'join'
      }).then((res) => {
        const data = res.data;
        that.teamList = data.list;
        if (that.teamList.length == 0) {
          that.username =  JSON.parse(localStorage.getItem('userInfo')).username
        }
      });
    },
    goToMatchDetail(item) {
      window.open(item.url);
    },
    goToTeamDetail(item) {
      this.$router.push({path: '/team/detail', query: {team: JSON.stringify(item), type: 'join'}});
    },
    openConfirm(team) {
      this.currentTeam = team
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `退出团队`,
        text: '你确定要退出这个团队吗？',
        acceptText: '是的',
        cancelText: '让我在考虑一下',
        accept: this.acceptAlert
      })
    },
    acceptAlert() {
      let that = this
      exitTeam({
        access_token: getToken(),
        teamId: that.currentTeam.id
      }).then((res) => {
        if (res.data.err_code === 0) {
          this.$vs.notify({
            color: 'success',
            title: '操作成功',
            text: '你已经退出团队！'
          })
          this.getList();
        }
      });
    },
    onCopy() {
      this.$vs.notify({
        color: 'success',
        title: '复制成功',
        text: '快发给队长邀请你进团队吧！'
      })
    },
    onError() {
      this.$vs.notify({
        color: 'error',
        title: '复制失败',
        text: '请刷新页面后尝试。'
      })
    }
  },
  created() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
#team-list {
  .item-view-primary-action-btn {
    color: #2c2c2c !important;
    background-color: #f6f6f6;
    min-width: 50%;
  }

  .item-view-secondary-action-btn {
    min-width: 50%;
  }
}
</style>
